import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'components/components/atoms';
import breakpoints from 'utils/breakpoints';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { AspectRatio } from 'react-aspect-ratio';
import cx from 'classnames';
import { hasPrice } from 'utils/parsePrice';

import { colors } from 'utils/tailwindColors';
const CardContainer = styled.div`
  width: 100%;
  margin-top: 0.313rem;
  margin-bottom: 0.25rem;
  @media ${breakpoints.md} {
    margin-bottom: 0.25rem;
  }
`;

const Card = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
  @media ${breakpoints.md} {
    margin-bottom: 1rem;
  }
`;

const AvailableFlag = styled.div`
  border-radius: 0.813rem;
  min-height: 1.625rem;
  width: fit-content;

  @media ${breakpoints.md} {
    ${({ islogo }) =>
      islogo
        ? ''
        : `${Card}:hover & {
      color: white;
      background-color: ${colors['mattamy-blue-light']};
    }`}
  }

  ${({ isMobile, islogo }) =>
    islogo ? '' : isMobile ? 'min-width: 7.5rem;' : 'min-width: 8rem;'}
`;

const CardTitle = styled.div`
  letter-spacing: -0.029rem;
`;

const CardDescription = styled.div.attrs({
  className:
    'font-graphie text-mattamy-blue text-base leading-relaxed md:leading-5  md:mb-0 flex items-start',
})`
  letter-spacing: 0.007rem;
`;

const Img = styled.img`
  height: 15.5rem;
`;

const ImageContainer = styled.div`
  height: 15.5rem;
`;

const CardInfoContainer = styled.div`
  min-height: 15.5rem;
`;

const ProductInfo = styled.div`
  height: 8rem;
`;

const StyledButton = styled(Button)`
  min-height: 3.125rem;
`;
const CommunityCard = (props) => {
  const {
    imageUrl,
    imageAlt,
    bubbletext,
    paragraph,
    title,
    subtitle,
    startingFromLabel,
    startingFrom,
    noPriceText,
    page,
    counter,
    numberPerPage,
    ctas,
  } = props;

  const maxCounter = page * numberPerPage;
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const isTablet = ['md'].includes(breakpoint);
  const cta = ctas && ctas[0];
  const hasStartingFromPrice = hasPrice(startingFrom);
  const priceText = hasStartingFromPrice
    ? startingFromLabel + ' ' + startingFrom
    : noPriceText;

  return (
    <CardContainer className={maxCounter > counter ? '' : 'hidden'}>
      <a
        href={cta && cta.href}
        target={(cta && cta.target) || '_self'}
        aria-label={
          title +
          ' ' +
          subtitle +
          ' ' +
          paragraph +
          priceText +
          '. View ' +
          title +
          ' information. ' +
          (cta && cta.target && cta.target === '_blank'
            ? '(Opens in new tab)'
            : '')
        }
      >
        <Card className='w-full bg-mattamy-white flex flex-col lg:flex-row justify-center items-start'>
          <ImageContainer className='w-full h-full text-center relative rounded overflow-hidden w-1/2'>
            <div className='overflow-hidden rounded'>
              <Img
                src={imageUrl}
                alt={imageAlt || ''}
                className={'bg-gray-300 object-cover w-full'}
              />
            </div>
          </ImageContainer>

          <CardInfoContainer className='w-full h-full text-left w-1/2 flex flex-col justify-between pl-4'>
            <div className='flex flex-col'>
              {bubbletext && (
                <div className='flex flex-row mb-1'>
                  <AvailableFlag
                    isMobile={isMobile}
                    islogo={false}
                    className='flex items-center justify-center bg-white border-mattamy-blue-light border-2 border-mattamy-blue-light hover:md:bg-mattamy-blue-light
                mt-1 md:mt-0 hover:md:text-white text-mattamy-blue-light px-2'
                  >
                    <p className='px-1 text-center font-trade-gothic-20 uppercase text-sm tracking-wide leading-3 mt-1'>
                      {bubbletext}
                    </p>
                  </AvailableFlag>
                </div>
              )}
              <CardTitle className='font-trade-gothic-20 text-mattamy-blue text-3xl leading-8 md:mt-1 block'>
                {title}
              </CardTitle>
              <ProductInfo className='pt-2 lg:pt-0 w-full flex flex-col'>
                <div className='block'>
                  {subtitle && (
                    <CardDescription className='items-start'>
                      <p className='break-normal mt-1'>{subtitle}</p>
                    </CardDescription>
                  )}
                  {paragraph && (
                    <CardDescription className='items-start pb-1'>
                      <p className='break-normal mt-1'>{paragraph}</p>
                    </CardDescription>
                  )}
                </div>
              </ProductInfo>
            </div>

            {((!hasStartingFromPrice && noPriceText) ||
              (hasStartingFromPrice && startingFromLabel)) && (
              <StyledButton
                color={'action-blue'}
                variant='filled'
                height={true}
                className='block text-base pt-0 pb-0 md:w-full'
                buttonDescription={priceText}
              >
                {priceText}
              </StyledButton>
            )}
          </CardInfoContainer>
        </Card>
      </a>
    </CardContainer>
  );
};

CommunityCard.propTypes = {
  props: PropTypes.object,
};

export default CommunityCard;
